import { RefObject, useEffect } from "react";

function useOutsideClick(
  ref: RefObject<HTMLElement | undefined>,
  callback: () => void,
) {
  const handleClick = (e: globalThis.MouseEvent | globalThis.TouchEvent) => {
    if (ref.current && !ref.current.contains(e.target as globalThis.Node)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);
    document.addEventListener("touchstart", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  });
}

export default useOutsideClick;
